import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  webinarListRequest,
  webinarListSuccess,
  webinarListFailure,
} from '../reducers/contentList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedwebinarsId, selectedwebinars, selectedVersionId, getSelectedThinktool} from '../selectors'

const API = `${API_LINK}api/user`;

function* webinarsListAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedModuleId } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/allWebinars?program_id=${selectedProgramId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'webinars-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerWebinarsListSaga() {
  try {
   
    const response = yield call(webinarsListAxios);

    const responseFromwebinarsList = response.data;
    
    yield put(webinarListSuccess(responseFromwebinarsList.data.components[0].content));

    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    
    yield put(webinarListFailure(error.response));
  }
}

export function* watcherWebinarsListSaga() {
  yield takeLatest(webinarListRequest().type, workerWebinarsListSaga);
}
